import React, { FC } from "react";
import {
  downloadProductDocumentZip,
  IGpsrProduct,
} from "../store/slices/gpsrProductsSlice";
import ProgressBar from "./ProgressBar";
import EditIcon from "./Icons/EditIcon";
import DownloadIcon from "./Icons/DownloadIcon";
import DeleteIcon from "./Icons/DeleteIcon";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../hooks/redux";
import { usePermissions } from "../hooks/usePermissions";

interface GpsrAllProductsTableProps {
  products: IGpsrProduct[];
  openModalHandle: (productId: string, productName: string) => void;
}

const GpsrAllProductsTable: FC<GpsrAllProductsTableProps> = ({
  products,
  openModalHandle,
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  // Subuser: edit / delete require gpsr_write (ZIP download is read-only).
  const { can } = usePermissions();
  const canWrite = can('gpsr_write');

  return (
    <table className="table gpsr-table">
      <thead>
        <tr>
          <th>{t("gpsr:products_table_name")}</th>
          <th>{t("gpsr:products_table_date")}</th>
          <th>{t("gpsr:products_table_edit")}</th>
          <th className="th-w-180">{t("gpsr:products_table_pdf")}</th>
          <th className="th-w-180">{t("gpsr:products_table_delete")}</th>
        </tr>
      </thead>
      <tbody>
        {products.map((item: IGpsrProduct) => (
          <tr key={item.id}>
            <td>{item.name}</td>
            <td>{item.date}</td>
            <td>
              <div className="gpsr-edit-wrapper">
                <div className="gpsr-edit-progress-col">
                  <ProgressBar progress={item.progress} />
                </div>
                <div className="gpsr-edit-btn-col">
                  <button
                    className="gpsr-action-btn gpsr-action-btn-edit"
                    onClick={() =>
                      navigate(`/features/gpsr/product/edit/${item.id}`)
                    }
                    disabled={!canWrite}
                    title={!canWrite ? t('subuser_no_permission_tooltip') : undefined}
                  >
                    <EditIcon />
                  </button>
                </div>
              </div>
            </td>
            <td>
              <button
                className="gpsr-action-btn gpsr-action-btn-download"
                onClick={() => dispatch(downloadProductDocumentZip({productId: item.id, productName: item.name}))}
              >
                <DownloadIcon />
              </button>
            </td>
            <td>
              <button
                className="gpsr-action-btn gpsr-action-btn-delete"
                onClick={() => openModalHandle(item.id, item.name)}
                disabled={!canWrite}
                title={!canWrite ? t('subuser_no_permission_tooltip') : undefined}
              >
                <DeleteIcon />
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default GpsrAllProductsTable;
